<template>
    <router-link v-if="showingResults" :to="route" class="button button--type-tertiary button--size-large">
        <div class="back-to-results">
            <div class="back-to-results__link">
                {{ $t('pages.referrals.new.microcopy.back_to_results') }}
            </div>

            <div class="back-to-results__preview">
                <common-user-avatar
                    v-for="result in results.slice(0, shownItemsCount)"
                    :key="result.id"
                    :user="result"
                    size="user-menu"
                ></common-user-avatar>
            </div>

            <div v-if="results.length > shownItemsCount" class="back-to-results__more">
                + {{ results.length - shownItemsCount }}
            </div>
        </div>
    </router-link>
</template>

<script>
    export default {
        props: {
            route: { type: Object, required: true },
            results: { type: Array, required: true },
            shownItemsCount: { type: Number, default: 3 },
        },

        computed: {
            showingResults() {
                if (this.$router.previousRoute && this.$router.previousRoute.name === 'referrals.new.results') return true
                else return false
            },
        },
    }
</script>
